export default __webpack_public_path__ + "static/media/3.23a5387f.png";